import { connect } from 'react-redux'
import { selectTwitterRecipients } from 'ducks/drafts'
import Header from './view'

const select = state => ({
  recipients: selectTwitterRecipients(state),
})

export default connect(select)(Header)
